import { postV1 } from '@/common/utils/ajax'

const setFeedbacks = (params) => postV1('feedbacks', params)

export default {
    setFeedbacks
}